import { authSliceSelectors, useAppSelector } from "@/store";
import { normalizeRole } from "@/utils/normalizeRole";

export function useSession() {
  const { expedition, ...session } = useAppSelector(authSliceSelectors.selectSession);

  return {
    ...session,
    expedition: {
      ...expedition!,
      role: normalizeRole(expedition?.role)
    }
  };
}
